import React from 'react';

const Plus = ({ color = 'currentColor', size=35 }: { color?: string, size?: number }) => {
  return <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M 14,7.9999999 H 7.9999996 V 14 H 6.0000001 V 7.9999999 H 0 v -2 H 6.0000001 V 0 H 7.9999996 V 6 H 14 Z"
      fill={color}
      id="path4"/>
  </svg>;
};

export default Plus;
